import { render, staticRenderFns } from "./BpmBizTaskOptModal.vue?vue&type=template&id=47e9f22e&scoped=true&"
import script from "./BpmBizTaskOptModal.vue?vue&type=script&lang=js&"
export * from "./BpmBizTaskOptModal.vue?vue&type=script&lang=js&"
import style0 from "./BpmBizTaskOptModal.vue?vue&type=style&index=0&id=47e9f22e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e9f22e",
  null
  
)

export default component.exports